import { render, staticRenderFns } from "./AddCampaign.vue?vue&type=template&id=58bf0d48&"
import script from "./AddCampaign.vue?vue&type=script&lang=js&"
export * from "./AddCampaign.vue?vue&type=script&lang=js&"
import style0 from "./AddCampaign.vue?vue&type=style&index=0&id=58bf0d48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports